import React from 'react';
import { CheckCircle2, FileText, Download } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { useTranslation } from 'react-i18next';

interface Props {
  onNext?: () => void;
  onPrevious?: () => void;
  allStepData?: any;
}

export const Confirmation: React.FC<Props> = ({ allStepData }) => {
  const { t } = useTranslation();
  const serviceData = allStepData?.[2] || {
    serviceType: 'meter-replacement',
    serviceTitle: 'Meter Replacement',
    serviceEta: '5-10 days',
    contactNumber: '2345678765',
    requestTime: '7/13/2026, 5:44:34 PM'
  };
  
  const requestId = `SRQ-${Math.floor(10000000 + Math.random() * 90000000)}`;

  const handleReset = () => {
    window.location.hash = '#verify-identity';
    window.location.reload();
  };

  return (
    <div className="flex flex-col lg:flex-row gap-6">
      {/* Left Column */}
      <div className="flex-1">
        <div className="bg-white rounded-2xl p-8 border border-green-200 shadow-sm text-center mb-6">
          <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-8 h-8 text-green-500" />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2">{t("Service Request Submitted!")}</h2>
          <p className="text-gray-500 max-w-sm mx-auto mb-6">
            {t("Your service request has been submitted successfully. A confirmation email has been sent.")}
          </p>

          <Button variant="outline" className="text-gray-700 bg-white hover:bg-gray-50 border border-gray-300">
            <Download className="w-4 h-4 mr-2" />
            {t("Download Receipt")}
          </Button>
        </div>

        {/* Receipt Details */}
        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden text-left mb-8">
          <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
            <h3 className="font-semibold text-gray-900 flex items-center gap-2">
              <FileText className="w-5 h-5 text-gray-400" />
              {t("Service Request Receipt")}
            </h3>
          </div>
          <div className="p-6 space-y-4">
            <div className="flex justify-between items-center pb-4 border-b border-slate-200">
              <span className="text-slate-500">{t("Request ID")}</span>
              <span className="font-bold text-blue-600">{requestId}</span>
            </div>
            <div className="flex justify-between items-center pb-4 border-b border-slate-200">
              <span className="text-slate-500">{t("Service Type")}</span>
              <span className="font-medium text-gray-900">{serviceData.serviceTitle || t("Service Request")}</span>
            </div>
            <div className="flex justify-between items-center pb-4 border-b border-slate-200">
              <span className="text-slate-500">{t("Est. Resolution")}</span>
              <span className="font-medium text-gray-900">{serviceData.serviceEta || 'Varies'}</span>
            </div>
            <div className="flex justify-between items-center pb-4 border-b border-slate-200">
              <span className="text-slate-500">{t("Contact")}</span>
              <span className="font-medium text-gray-900">{serviceData.contactNumber}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-slate-500">{t("Submitted At")}</span>
              <span className="font-medium text-gray-900">{serviceData.requestTime}</span>
            </div>
          </div>

          <Button 
            onClick={handleReset}
            variant="outline"
            className="border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            {t("Submit Another Request")}
          </Button>
        </div>
      </div>

    </div>
  );
};
